import { IProductListingStatusLabels } from '@models/IProductListingStatusLabels';
import { ISearchSummaryRowResult } from '@models/ISearchSummaryRowResult';
import SearchSummaryRow from './SearchSummaryRow';

interface Props {
  readonly searchSummaryResults: ISearchSummaryRowResult[];
  readonly searchValue: string;
  readonly productsStatusLabels: IProductListingStatusLabels;
  readonly resultsFoundLabel?: string;
}

const SearchSummaryResults = ({
  searchSummaryResults,
  searchValue,
  productsStatusLabels,
  resultsFoundLabel,
}: Props) => {
  const totalResultsFound = searchSummaryResults
    .map((summaryResult) => summaryResult.totalCount)
    .reduce((partialSum, totalCount) => partialSum + totalCount, 0);

  return (
    <div data-testid="CT-48-Search-Summary-Results-Container">
      {resultsFoundLabel && (
        <p
          className="body-three container pt-5 text-grey-600 lg:pt-[70px]"
          data-testid="CT-48-Search-Summary-Results-Found-Label"
        >
          {resultsFoundLabel.replace('{0}', `${totalResultsFound}`)}
        </p>
      )}

      <div
        className={`component-padding pt-15 ${
          resultsFoundLabel ? 'lg:pt-[104px]' : 'lg:pt-[150px]'
        }`}
      >
        <div
          className="flex flex-col gap-20 lg:gap-[150px]"
          data-testid="CT-48-Search-Summary-Results-Row-Container"
        >
          {searchSummaryResults.map((summary) => (
            <SearchSummaryRow
              key={summary.title}
              {...summary}
              productsStatusLabels={productsStatusLabels}
              value={searchValue}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default SearchSummaryResults;
